<template>
  <div class="custom-table__footer__row d-flex align-items-center justify-content-between">
    <div class="custom-table__footer__rows d-flex align-items-center">
      <span>{{ $filters.firstUpper($t("pocetRadkuNaStrance")) }}</span>
      <div class="custom-control__select custom-control__select--small">
        <div
          :class="{ opened: openedRowsSelect }"
          class="custom-control__select__selected"
          @click="toggleOpenedRowSelect(page.rowsPerPage)"
        >
          <span>{{ page.rowsPerPage }}</span>
        </div>
        <div :class="{ opened: openedRowsSelect }" class="custom-control__select__options">
          <div v-for="(item, index) in rowsPerPageOptions" :key="index">
            <div
              v-if="apiUser && (apiUser.isIotAdmin || (!apiUser.isIotAdmin && item < 500))"
              class="custom-control__select__option d-flex align-items-center"
              @click="
                () => {
                  toggleOpenedRowSelect(item)
                  resetPage()
                  reloadItems()
                }
              "
            >
              <span class="font-weight-light">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-table__paginator">
      <div class="custom-table__paginator__control prev">
        <div
          v-if="page.currentPage > 0"
          class="custom-table__paginator__link"
          @click="
            () => {
              prevPage()
              reloadItems()
            }
          "
        />
      </div>
      <div class="custom-table__paginator__pages">
        <span v-if="page.currentPage == 0">1</span>
        <span v-else>{{ page.currentPage * page.rowsPerPage + 1 }}</span>
        -
        <span v-if="page.itemsTotalCount < page.currentPage * page.rowsPerPage + Number(page.rowsPerPage)">
          {{ page.itemsTotalCount }}
        </span>
        <span v-else>
          {{ page.currentPage * page.rowsPerPage + Number(page.rowsPerPage) }}
        </span>
        {{ $t("pagingZ") }}
        {{ page.itemsTotalCount }}
      </div>

      <div class="custom-table__paginator__control next">
        <div
          v-if="page.currentPage < page.itemsTotalCount / Number(page.rowsPerPage) - 1"
          class="custom-table__paginator__link"
          @click="
            () => {
              nextPage()
              reloadItems()
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/store/modules/auth"

export default {
  props: {
    page: Object
  },
  emits: ["rowsPerPage", "reloadItems", "nextPage", "prevPage"],
  setup() {
    const authStore = useAuthStore()

    return { authStore }
  },
  data() {
    return {
      openedRowsSelect: false,
      rowsPerPageOptions: [2, 10, 20, 50, 100, 500, 1000]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  methods: {
    resetPage() {
      this.$emit("page", 0)
    },
    toggleOpenedRowSelect(rPP) {
      this.openedRowsSelect = !this.openedRowsSelect
      this.$emit("rowsPerPage", rPP)
    },
    reloadItems() {
      this.$emit("reloadItems")
    },
    nextPage() {
      this.$emit("nextPage")
    },
    prevPage() {
      this.$emit("prevPage")
    }
  }
}
</script>

<style lang="scss" scoped></style>
